<script lang="ts">
const styles = _stylex_create({
  footer: {
    backgroundColor: colors.pageBg,
    paddingBlockStart: spacing.sm,
    paddingBlockEnd: spacing.xl,
    paddingInline: spacing.md,
  },
  inner: {
    maxInlineSize: size.contentMax,
    marginInline: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    color: colors.textMuted,
    fontFamily: type.uiFamily,
    fontSize: type.meta,
    lineHeight: '1.6',
  },
  text: {
    margin: 0,
  },
  link: {
    'color': colors.textPrimary,
    'textDecorationLine': 'underline',
    'textUnderlineOffset': '0.18em',
    'textDecorationThickness': '1px',
    ':focus-visible': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: colors.focusRing,
      outlineOffset: '3px',
    },
  },
  license: {
    margin: 0,
  },
})
</script>
<script setup lang="ts">
import __MACROS__stylex_attrs from "/vue-macros/define-stylex/stylex-attrs";
import { create as _stylex_create, props as _stylex_props } from '@stylexjs/stylex'
import { colors, size, spacing, type } from '#/tokens.stylex'


</script>

<template>
  <footer v-bind="__MACROS__stylex_attrs(_stylex_props(styles.footer))">
    <div v-bind="__MACROS__stylex_attrs(_stylex_props(styles.inner))">
      <p v-bind="__MACROS__stylex_attrs(_stylex_props(styles.text))">
        Free software. Source on
        <a
          v-bind="__MACROS__stylex_attrs(_stylex_props(styles.link))"
          href="https://github.com/BeiyanYunyi/MeowPI"
          target="_blank"
          rel="noreferrer"
        >
          GitHub
        </a>
      </p>
      <p v-bind="__MACROS__stylex_attrs(_stylex_props(styles.license))">
        Licensed under AGPL-3.0
      </p>
    </div>
  </footer>
</template>
